import { TemplatePage } from './types';

const realEstatePage: TemplatePage = {
  header: {
    color: '#F5D7BC',
    icon: 'images/video-templates/real_estate.jpg',
    title: 'Real Estate Video Templates Collection',
    title_meta: '50+ Free Real Estate Video Templates',
    description_meta:
      'Check out Wave.video’s collection of 50+ real estate video templates. Create high-quality videos to show ' +
      'off your listings, market properties, and more.',
    description:
      'Gain leads and land new clients for your business with this outstanding collection of 50+ professional real ' +
      'estate templates. Create high-quality <a href="https://wave.video/real-estate-video" target="_blank">real ' +
      'estate videos</a> to show off your listings, organize virtual home tours, leverage customer testimonials, ' +
      'market properties, announce open houses, and more.'
  },
  footer: {
    category: 'Real Estate',
    description:
      'Wave.video’s extensive collection of high-quality real estate video templates makes it simple to create ' +
      'engaging videos in a matter of minutes. All the templates are free and easy to personalize to suit your ' +
      'brand and topic.'
  },
  content: [
    {
      type: 'templates',
      title: 'real estate',
      search: { category: '/Industries/Real Estate' }
    },
    {
      type: 'stocks',
      title: 'real estate',
      search: { name: 'real estate' }
    },
    { type: 'calendar' }
  ]
};

export default realEstatePage;
